import BaseSlideMenu from "../../sisu/menu/BaseSlideMenu.sisu";

export default BaseSlideMenu;